// packages/core/src/plan-features.ts
// Feature gating by subscription plan

export const PLAN_FEATURES = {
  solo: [
    'pipeline',
    'shows',
    'setlists',
    'debriefs',
    'contracts',
    'cancellations',
    'wellness',
    'press',
    'vip',
    'analytics_basic',
    'territory',
  ],
  management: [
    // Everything in solo
    'pipeline',
    'shows',
    'setlists',
    'debriefs',
    'contracts',
    'cancellations',
    'wellness',
    'press',
    'vip',
    'analytics_basic',
    // Plus these
    'territory',
    'ticketing',
    'merch',
    'marketing',
    'travel',
    'logistics',
    'broker',
    'analytics',
    'royalties',
    'crew_pool',
    'team_permissions',
    'email_rules',
    'assistant',
    'team',
  ],
  enterprise: [
    // Everything in management
    'pipeline',
    'shows',
    'setlists',
    'debriefs',
    'contracts',
    'cancellations',
    'wellness',
    'press',
    'vip',
    'analytics_basic',
    'territory',
    'ticketing',
    'merch',
    'marketing',
    'travel',
    'logistics',
    'broker',
    'analytics',
    'royalties',
    'crew_pool',
    'team_permissions',
    'email_rules',
    'assistant',
    'team',
    // Plus these
    'admin_panel',
    'api_access',
    'white_label',
  ],
} as const

export type PlanFeature = (typeof PLAN_FEATURES)[keyof typeof PLAN_FEATURES][number]

/** Check if a plan includes a feature */
export function planHasFeature(plan: string, feature: string): boolean {
  const features = PLAN_FEATURES[plan as keyof typeof PLAN_FEATURES]
  if (!features) return false
  return (features as readonly string[]).includes(feature)
}

/** Map of sidebar route paths to their feature keys */
export const ROUTE_FEATURE_MAP: Record<string, string> = {
  '/': 'pipeline',           // dashboard always visible
  '/dashboard': 'pipeline',
  '/inbox': 'pipeline',
  '/pipeline': 'pipeline',
  '/performances': 'shows',
  '/shows': 'shows',
  '/tours': 'shows',
  '/venues': 'shows',
  '/advancing': 'shows',
  '/rider': 'shows',
  '/rehearsals': 'shows',
  '/setlists': 'setlists',
  '/debriefs': 'debriefs',
  '/contracts': 'contracts',
  '/cancellations': 'cancellations',
  '/wellness': 'wellness',
  '/press': 'press',
  '/vip': 'vip',
  '/territory': 'territory',
  '/ticketing': 'ticketing',
  '/merch': 'merch',
  '/marketing': 'marketing',
  '/travel': 'travel',
  '/logistics': 'logistics',
  '/broker': 'broker',
  '/brokers': 'broker',
  '/analytics': 'analytics',
  '/audience': 'analytics',
  '/royalties': 'royalties',
  '/finance/documents': 'royalties',
  '/payments': 'royalties',
  '/crew/pool': 'crew_pool',
  '/team-permissions': 'team_permissions',
  '/email-rules': 'email_rules',
  '/assistant': 'assistant',
  '/team': 'team',
  '/settings/epks': 'pipeline',
  '/settings/artist': 'pipeline',
}
